import React from 'react'
import StarDisplay from './StarDisplay'

// Big-number rating summary block.
// Used on product detail (Məhsul rəyi), shop page (Satıcı rəyi),
// and site reviews page (Platforma rəyi).
//
// Hides gracefully when both `value` is 0 and `count` is 0.

const RatingSummary = ({
    value = 0,
    count = 0,
    subtitle,
    size = 'md',  // 'sm' | 'md' | 'lg'
    align = 'left', // 'left' | 'center'
    className = '',
}) => {
    const safeValue = Math.max(0, Math.min(5, Number(value) || 0))
    const safeCount = Math.max(0, Number(count) || 0)

    const sizeMap = {
        sm: { num: 'text-3xl',  star: 12, label: 'text-xs',  of: 'text-sm'  },
        md: { num: 'text-4xl',  star: 16, label: 'text-sm',  of: 'text-base' },
        lg: { num: 'text-5xl',  star: 20, label: 'text-sm',  of: 'text-lg'  },
    }[size] || { num: 'text-4xl', star: 16, label: 'text-sm', of: 'text-base' }

    const alignment = align === 'center'
        ? 'items-center text-center'
        : 'items-start text-left'

    return (
        <div className={`flex flex-col gap-1.5 ${alignment} ${className}`}>
            <div className='flex items-baseline gap-1'>
                <span className={`font-black text-slate-900 leading-none ${sizeMap.num}`}>
                    {safeValue > 0 ? safeValue.toFixed(1) : '—'}
                </span>
                <span className={`text-slate-400 font-semibold ${sizeMap.of}`}>/ 5</span>
            </div>
            <StarDisplay value={safeValue} size={sizeMap.star} />
            <p className={`text-slate-500 ${sizeMap.label}`}>
                {safeCount > 0 ? `${safeCount} rəy` : 'Hələ rəy yoxdur'}
            </p>
            {subtitle && (
                <p className='text-xs text-slate-400'>{subtitle}</p>
            )}
        </div>
    )
}

export default RatingSummary
